module.exports = __webpack_public_path__ + "img/pic_india_08.8059e2fc.jpg";